export default __webpack_public_path__ + "static/media/listen-to-the-river.6d90ba23.jpg";